module.exports = __webpack_public_path__ + "assets/header-bg.d4847ace.svg";